import '../../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $ } from '../../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../../node_modules/lit-element/lit-element.js';
import css_248z from './footer-legal.scss.js';

class FooterLegal extends s {
    render() {
        return $ `<nav class="footer-legal" role="navigation"><ul class="footer-legal__list"><slot></slot></ul></nav>`;
    }
}
FooterLegal.styles = css_248z;
customElements.define('footer-legal', FooterLegal);

export { FooterLegal };
